<div>
	<div class="modal-header">
		<h4 class="modal-title">Editer la société {{companyName}}</h4>
		<button type="button" class="close" aria-label="Close" (click)="cancelDialog()"><span aria-hidden="true">&times;</span></button>
	</div>

	<div class="modal-body">
		<form [formGroup]="companyEditForm">
			<div class="form-group">
				<label for="name">Nom</label>
				<input required #nameControl id="name" type="text" class="form-control" formControlName="nameControl" placeholder="Nom" value="{{companyName}}" ngbAutofocus (input)="nameControl.value=nameControl.value.toUpperCase()">
			</div>
		</form>
	</div>

	<div class="modal-footer">
		<button type="button" class="btn btn-light" (click)="cancelDialog()">Annuler</button>
		<button type="button" class="btn btn-primary" [disabled]="!enableAction || !companyEditForm.valid" (click)="save()">{{buttonText}}</button>
	</div>
</div>
